import { AxiosRequestConfig } from "axios";

export const getScanConfig = (qrId: string): AxiosRequestConfig => ({
  method: "get",
  url: `/qrcode/${qrId}/scan`,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
});
